import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { setAuthToken } from '@/shared/api';

interface StaffTokenState {
  readonly token: string | null;
  readonly setToken: (token: string | null) => void;
}

/**
 * The **token only**. Who the staff user is and what they may do is server
 * state and lives in TanStack Query — duplicating it here would give the panel
 * two sources of truth for a permission (CLAUDE.md §7.3).
 *
 * The store is also what feeds the http client's Authorization header, so
 * setting it here and rehydrating it on boot keeps the two in step.
 */
export const useStaffTokenStore = create<StaffTokenState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token: string | null): void => {
        setAuthToken(token);
        set({ token });
      },
    }),
    {
      name: 'clinic.staff.token',
      onRehydrateStorage:
        () =>
        (state): void => {
          setAuthToken(state?.token ?? null);
        },
    },
  ),
);
